import { List, Map as ImmutableMap } from 'immutable';
import I18n from 'I18n';
import { getReferenceLabel } from 'reporting-data/v2/dataset/datasetRecords';
export const getFlattenedRowData = (rows, groupedRowData, showColumnSubtotals, fullDataset) => {
  let flattenedRowModel = List([]);
  const pushFlatData = (row, rowMetaData) => {
    flattenedRowModel = flattenedRowModel.push(ImmutableMap({
      data: row,
      rowMetaData
    }));
  };
  const updateRowCount = (rowCount, field, parentRows) => {
    const dataIndex = flattenedRowModel.findIndex(searchPoint => parentRows.reduce((result, val, key) => {
      const newResult = searchPoint && searchPoint.getIn(['rowMetaData', key, 'key']) === val;
      return result && newResult;
    }, true));
    flattenedRowModel = dataIndex !== -1 ? flattenedRowModel.setIn([dataIndex, 'rowMetaData', field, 'rowspan'], rowCount) : flattenedRowModel;
  };
  const getFlatDataRecursive = (row, key, rowEncodingIndex = 0, rowMetaData = ImmutableMap({}), parentRows = ImmutableMap({})) => {
    const field = rows.getIn([rowEncodingIndex, 'field']);
    parentRows = parentRows.set(field, key);
    rowMetaData = rows.count() ? rowMetaData.set(field, ImmutableMap({
      key
    })) : rowMetaData;
    if (!List.isList(row)) {
      let rowCount = row.reduce(
      // @ts-expect-error as row is an orderedMap here, nestedKey is a string
      (accum, nestedRow, nestedKey) => {
        return accum + getFlatDataRecursive(nestedRow, nestedKey, rowEncodingIndex + 1, rowMetaData, parentRows);
      }, 0);
      if (showColumnSubtotals) {
        const subtotalMetaData = ImmutableMap({
          [field]: ImmutableMap({
            key: I18n.text('report.details.header.SUBTOTAL_WITH_DIMENSION', {
              dimension: getReferenceLabel(fullDataset, field, key)
            }),
            colspan: rows.count() - (rowEncodingIndex + 1),
            rowspan: 1
          }),
          isSubtotalsColumn: true,
          columnSubtotalField: field
        });
        const groupData = flattenedRowModel.takeLast(rowCount);
        const flattenedGroupData = groupData.reduce((accum, groupItem) => {
          return /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */(
            accum.concat(groupItem.get('data'))
          );
        }, List());
        pushFlatData(flattenedGroupData, subtotalMetaData);
        rowCount = rowCount + 1;
      }
      updateRowCount(rowCount, field, parentRows);
      return rowCount;
    } else {
      // We know that row is definiely a list becuase of the above check
      pushFlatData(row, rowMetaData);
      updateRowCount(1, field, parentRows);
      return 1;
    }
  };
  groupedRowData.forEach((initialRow, initialKey) => {
    return getFlatDataRecursive(initialRow, initialKey);
  });
  return flattenedRowModel;
};